import {ValueObject} from '@s-ui/domain'

export class RelatedVehiclesListValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Array} params.items
   * */

  getItems() {
    return this._items
  }
}
